/* import __COLOCATED_TEMPLATE__ from './multiselect-question.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';

export default class RequestPrescreenerQuestionTypesMultiselectQuestion extends Component {
  get currentValues() {
    return Array.isArray(this.args.validationModel?.value) ? this.args.validationModel.value : [];
  }

  get maxSelections() {
    return this.args.validationModel?.maxLength || 3;
  }

  get isAtMaxSelections() {
    return this.currentValues.length >= this.maxSelections;
  }

  @action
  isOptionChecked(name, option) {
    return this.currentValues.includes(option);
  }

  @action
  isOptionDisabled(name, option) {
    const isChecked = this.currentValues.includes(option);
    return !isChecked && this.isAtMaxSelections;
  }

  @action
  onToggleMultiselect(question, option) {
    let current = this.currentValues;
    let values = [];
    if (current.includes(option)) {
      values = current.filter(v => v !== option);
    } else {
      values = [...current, option];
    }

    this.args.onChange?.(question, values);
  }
}
